var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1173,
    height: 1178,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 1232,
    width: 1173,
    height: 1178
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 1597,
    width: 618,
    height: 618
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 1597,
    width: 618,
    height: 618
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 1597,
    width: 618,
    height: 618
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-128 -1232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 1822C132 1498.91 393.69 1237 716.5 1237 1039.31 1237 1301 1498.91 1301 1822 1301 2145.09 1039.31 2407 716.5 2407 393.69 2407 132 2145.09 132 1822Z",
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 1550.5C516 1439.21 606.215 1349 717.5 1349L717.5 1349C828.785 1349 919 1439.21 919 1550.5L919 1956.5C919 2067.79 828.785 2158 717.5 2158 606.215 2158 516 2067.79 516 1956.5Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 1551C598 1485.83 650.831 1433 716 1433L716 1433C781.17 1433 834 1485.83 834 1551L834 1846C834 1911.17 781.169 1964 716 1964L716 1964C650.831 1964 598 1911.17 598 1846Z",
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 1712.51C396 1669.7 430.703 1635 473.511 1635L980.489 1635C1023.3 1635 1058 1669.7 1058 1712.51L1058 2136.49C1058 2179.3 1023.3 2214 980.489 2214L473.511 2214C430.703 2214 396 2179.3 396 2136.49Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855.042 1791.1C839.617 1791.1 826.763 1778.24 827.405 1762.18 827.405 1746.75 840.259 1733.9 855.684 1733.9 871.109 1733.9 883.964 1746.75 883.964 1762.18 883.964 1769.89 880.75 1776.96 875.608 1782.1 869.824 1787.88 862.754 1791.1 855.042 1791.1ZM827.405 1701.76C813.266 1706.9 802.34 1717.83 795.27 1730.68 786.272 1748.04 784.986 1767.96 792.056 1785.96L822.906 1852.8 843.473 1895.22C845.401 1899.72 849.9 1902.29 855.042 1902.29 860.183 1902.29 864.682 1899.72 866.61 1895.22L887.177 1852.8 918.027 1786.6C921.241 1778.89 922.526 1770.53 922.526 1762.18 922.526 1717.19 876.251 1683.12 827.405 1701.76Z",
    fill: "#404040",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.646 2064.89 610.812 2013.48 610.812 1803.95 713.646 1855.37 713.646 2064.89ZM585.104 2013.48 507.979 2052.04 507.979 1842.51 585.104 1803.95 585.104 2013.48ZM941.165 1797.53 925.097 1832.23 945.021 1842.51 945.021 2052.04 867.896 2013.48 867.896 1927.99 842.188 1927.99 842.188 2013.48 739.354 2064.89 739.354 1855.37 784.986 1832.23 768.919 1797.53 726.5 1818.73 597.958 1754.46 469.417 1818.73 469.417 2114.38 597.958 2050.11 726.5 2114.38 855.042 2050.11 983.583 2114.38 983.583 1818.73 941.165 1797.53Z",
    fill: "#404040",
    fillRule: "nonzero",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocked);
export default __webpack_public_path__ + "static/media/map-locked.606f6f4e42331b4aab59b4d29151869b.svg";
export { ForwardRef as ReactComponent };